import { Divider } from '@reckon-web/divider';
import { Heading } from '@reckon-web/heading';
import { Stack } from '@reckon-web/stack';
import { Button } from '@reckon-web/button';

import { WidgetContainer } from '../../generic/wigetContainer';

import { User } from './user';

type AuthenticatedUsersProps = {
  users: Array<{
    firstName: string;
    lastName: string;
    emailOrUsername: string;
    onClick: () => void;
  }>;
  signInDifferentAccount: () => void;
};

export const AuthenticatedUsers = ({
  users,
  signInDifferentAccount,
}: AuthenticatedUsersProps) => {
  return (
    <WidgetContainer>
      <Stack margin="xxlarge" gap="xlarge">
        <Stack gap="xxlarge">
          <Heading align="center" level="5">
            Select account to continue
          </Heading>

          <Stack>
            {users.map((user, index) => (
              <User
                {...user}
                key={user?.emailOrUsername}
                isDivider={index < users.length - 1}
              />
            ))}
          </Stack>
        </Stack>

        <Stack align="center" gap="xlarge">
          <Divider />
          <Button
            onClick={signInDifferentAccount}
            label="Sign in with different account"
            weight="none"
          />
        </Stack>
      </Stack>
    </WidgetContainer>
  );
};
